import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_butt-karahi-luton/artifacts/dwb7qv2j_kqaK9%20%281%29.jpg";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Our Menu', path: '/menu' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header 
      data-testid="header"
      className="fixed top-0 w-full z-50 bg-white shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-28 md:h-32">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Butt Karahi Luton" 
              className="h-20 md:h-24 lg:h-28 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`text-base tracking-wider uppercase font-medium transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-brand-red'
                    : 'text-black hover:text-brand-red'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Phone CTA - Desktop */}
          <a
            href="tel:01582517786"
            data-testid="phone-cta"
            className="hidden md:flex items-center gap-2 bg-brand-red text-white px-8 py-4 font-semibold text-base tracking-wider uppercase hover:bg-red-700 transition-colors duration-300"
          >
            <Phone size={16} />
            <span>01582 517786</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-black p-2"
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div 
          className="md:hidden bg-white border-t border-gray-200"
          data-testid="mobile-nav"
        >
          <nav className="flex flex-col px-6 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`py-3 text-sm tracking-wider uppercase font-medium border-b border-gray-100 ${
                  isActive(link.path)
                    ? 'text-brand-red'
                    : 'text-black'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:01582517786"
              className="mt-4 flex items-center justify-center gap-2 bg-brand-red text-white px-6 py-3 font-semibold text-sm tracking-wider uppercase"
            >
              <Phone size={16} />
              <span>01582 517786</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
